import axiosInstance from "./AxiosInstanceMain";

export const getLeadSyncSettingsApi = async () => {
  const res = await axiosInstance.get( "/lead-sync/settings" );
  return res.data;
};

export const updateLeadSyncSettingsApi = async (data) => {
  const res = await axiosInstance.put( "/lead-sync/settings", data );
  return res.data;
};